import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {RestApi} from '../../auth/rest.api';

@Injectable({
  providedIn: 'root'
})
export class CommonServices {

  constructor(private _authHttp: RestApi) {
  }


  getObject(): Promise<any> {
    return this._authHttp.get('api/Environment/proxy').toPromise();
  }

  updateObject(proxy: IEnvironmentProxy): Promise<any> {
    return this._authHttp.post('api/Environment/proxy', proxy).toPromise();
  }

}
